import { FC } from 'react';
import styled from 'styled-components';

interface LinkTextProps {
  text: string;
  notCentered?: boolean;
}

const HiddenTxt = styled.span`
  opacity: 0;
  padding: 0 4px;
`;

const VisibleTxt = styled.span<{ notCentered?: boolean }>`
  align-items: center;
  display: flex;
  inset: 0;
  justify-content: ${({ notCentered }) => (notCentered ? '' : 'center')};
  position: absolute;
  transition: 300ms ease;
`;

export const LinkText: FC<LinkTextProps> = ({ text, notCentered }) => {
  return (
    <>
      <HiddenTxt className="hidden">{text}</HiddenTxt>
      <VisibleTxt className="visible" notCentered={notCentered}>
        {text}
      </VisibleTxt>
    </>
  );
};
